
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// These values are safe to expose in the client
// They are publicly available in the network requests anyway
const SUPABASE_URL = "https://riuvidvwhlkcvuowjkyo.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJpdXZpZHZ3aGxrY3Z1b3dqa3lvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwNjQ2OTIsImV4cCI6MjA1ODY0MDY5Mn0.3I6BPXmaI1nAMaPHMCr9DcaTq-X_Dw8a8JH5sZZDXU0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);
